import { RootStoreContext } from "core/providers/root-store.provider";
import React from "react";

export const useRootStore = () => {
   const ctx = React.useContext(RootStoreContext);
   if (!ctx) {
      throw new Error('useRootStore must be used inside RootStoreProvider');
   }
   return ctx;
};